export default "__VITE_ASSET__BlU0X6PB__"